"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActionsMenu = exports.ColumnActionItems = exports.ActionStatusIcon = exports.ListMenuStyle = exports.ColumnActions = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const RemoteTypeIcon_1 = require("../datagrid/cellFormatters/RemoteTypeIcon");
const ReRenderPlacePageContext_1 = require("../placePage/ReRenderPlacePageContext");
var ColumnActions;
(function (ColumnActions) {
    ColumnActions["Tag"] = "Tag";
    ColumnActions["Description"] = "Edit Description";
    ColumnActions["QualityWarning"] = "Data Quality Warning";
    ColumnActions["SensitiveLabels"] = "Sensitivity Label";
    ColumnActions["CustomLabels"] = "More Labels";
})(ColumnActions = exports.ColumnActions || (exports.ColumnActions = {}));
exports.ListMenuStyle = {
    fontWeight: 'normal',
    top: '-1px',
};
function ActionStatusIcon(props) {
    if (props.hover) {
        return react_1.default.createElement(catalog_icons_1.SvgActionsActive, null);
    }
    else {
        return react_1.default.createElement(catalog_icons_1.SvgActions, null);
    }
}
exports.ActionStatusIcon = ActionStatusIcon;
function ColumnActionItems(props) {
    var _a, _b;
    const customLabelsActionItemInfo = {
        value: ColumnActions.CustomLabels,
        displayValue: catalog_messages_1.Messages.MoreLabelsAction(),
        disabled: !props.canUpdate || !props.columnLuid,
    };
    const labelActionItemInfo = {
        value: 'labelActionSubmenu',
        displayValue: catalog_messages_1.Messages.LabelActionSubmenu(),
        menuItemInfos: [
            {
                value: ColumnActions.QualityWarning,
                displayValue: catalog_messages_1.Messages.DataQualityWarningAction(),
                disabled: !props.canUpdate || !props.columnLuid,
            },
            {
                value: ColumnActions.SensitiveLabels,
                displayValue: catalog_messages_1.Messages.SensitiveLabelAction(),
                disabled: !props.canUpdate || !props.columnLuid,
            },
        ],
        disabled: !props.canUpdate || !props.columnLuid,
    };
    if (props.customLabelCategoriesEnabled) {
        (_a = labelActionItemInfo.menuItemInfos) === null || _a === void 0 ? void 0 : _a.push({
            isDivider: true,
        });
        (_b = labelActionItemInfo.menuItemInfos) === null || _b === void 0 ? void 0 : _b.push(customLabelsActionItemInfo);
    }
    return [
        {
            value: ColumnActions.Tag,
            displayValue: catalog_messages_1.Messages.TagAction(),
            disabled: !props.canUpdate,
        },
        {
            value: ColumnActions.Description,
            displayValue: catalog_messages_1.Messages.EditDescriptionAction(),
            disabled: !props.canUpdate,
        },
        { isDivider: true },
        labelActionItemInfo,
    ];
}
exports.ColumnActionItems = ColumnActionItems;
function useActionsMenu(props) {
    const { columnLuid, columnName, columnRemoteType, enterDescriptionEdit, enterTaggingEdit } = props;
    const [isDialogShowing, setIsDialogShowing] = react_1.default.useState(false);
    const [action, setAction] = react_1.default.useState(null);
    const [isMenuShowing, setIsMenuShowing] = react_1.default.useState(false);
    const [isCustomDialogShowing, setIsCustomDialogShowing] = react_1.default.useState(false);
    const hideCustomDialog = react_1.default.useCallback(() => setIsCustomDialogShowing(false), [setIsCustomDialogShowing]);
    const { rerender } = react_1.default.useContext(ReRenderPlacePageContext_1.ReRenderPlacePageContext);
    const { renderDataQualityDialog, renderSensitiveLabelsDialog } = (0, catalog_core_1.useUIActions)();
    const onSelect = react_1.default.useCallback((value) => {
        const renderDialogParams = {
            content: {
                contentId: columnLuid,
                contentName: columnName,
                contentType: 'column',
                contentIcon: react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: columnRemoteType }),
                contentIconTitle: data_catalog_shared_1.RemoteTypeMappings[columnRemoteType](),
            },
            dismiss: () => {
                hideCustomDialog();
                rerender();
            },
        };
        switch (value) {
            case ColumnActions.Description:
                setIsDialogShowing(true);
                setAction(value);
                enterDescriptionEdit ? enterDescriptionEdit() : null;
                break;
            case ColumnActions.Tag:
                setIsDialogShowing(true);
                setAction(value);
                enterTaggingEdit ? enterTaggingEdit() : null;
                break;
            case ColumnActions.QualityWarning:
                if (columnLuid) {
                    renderDataQualityDialog(renderDialogParams).catch(_ => {
                        return;
                    });
                }
                break;
            case ColumnActions.SensitiveLabels:
                renderSensitiveLabelsDialog(renderDialogParams).catch(_ => {
                    return;
                });
                break;
            case ColumnActions.CustomLabels:
                setIsCustomDialogShowing(true);
                break;
            default:
                (0, catalog_core_1.assertUnreachable)(value);
                throw new Error('Unreachable - unknown column action');
        }
        setIsMenuShowing(false);
    }, [
        columnLuid,
        columnName,
        columnRemoteType,
        enterDescriptionEdit,
        enterTaggingEdit,
        hideCustomDialog,
        renderDataQualityDialog,
        renderSensitiveLabelsDialog,
        rerender,
    ]);
    return {
        isDialogShowing,
        setIsDialogShowing,
        action,
        onSelect,
        isMenuShowing,
        setIsMenuShowing,
        isCustomDialogShowing,
        hideCustomDialog,
    };
}
exports.useActionsMenu = useActionsMenu;
//# sourceMappingURL=ColumnActionsMenuHelper.js.map